import { render } from "./CreateRequest5.vue?vue&type=template&id=4535a707"
import script from "./CreateRequest5.vue?vue&type=script&lang=js"
export * from "./CreateRequest5.vue?vue&type=script&lang=js"

import "./CreateRequest5.vue?vue&type=style&index=0&id=4535a707&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__